import React from 'react'
import { buttonClass, ButtonStyle } from './helpers'

export type ButtonProps = {
  children:
    | React.ReactElement
    | string
    | number
    | (React.ReactElement | string | number)[]
  disabled?: boolean
} & ButtonStyle

type ButtonComponentProps = ButtonProps &
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >

const Button = React.forwardRef<HTMLButtonElement, ButtonComponentProps>(
  (
    {
      children,
      fullWidth,
      size = 'normal',
      variant,
      shadow,
      color,
      type = 'button',
      rounded,
      className,
      ...props
    }: ButtonComponentProps,
    forwardedRef
  ) => {
    return (
      // eslint-disable-next-line react/button-has-type
      <button
        ref={forwardedRef}
        // eslint-disable-next-line react/button-has-type
        className={buttonClass({
          color,
          fullWidth,
          size,
          variant,
          shadow,
          rounded,
          className
        })}
        // eslint-disable-next-line react/button-has-type
        type={type}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
